import AddFromRequestHistoryButton from "./AddFromRequestHistoryButton";
import AddFromTracesButton from "./AddFromTracesButton";

import type {
  SmartTableRequestImportPayload,
  SmartTableTraceImportPayload,
} from "@/queries/smart-tables";
import {
  HISTORY_IMPORT_COLUMN_CONFIG,
  HistoryImportSource,
} from "@/routes/smart-table/utils/historyImportTypes";

export interface AnchorCellImportTarget {
  cellId: string;
  columnId: string;
  type: HistoryImportSource;
}

interface AnchorCellImportDialogsProps {
  target: AnchorCellImportTarget | null;
  isImporting: boolean;
  tableId?: string;
  sheetId?: string;
  onOpenChange: (open: boolean) => void;
  onImport: (
    payload: SmartTableRequestImportPayload | SmartTableTraceImportPayload,
  ) => Promise<boolean>;
}

const AnchorCellImportDialogs = ({
  target,
  isImporting,
  tableId,
  sheetId,
  onOpenChange,
  onImport,
}: AnchorCellImportDialogsProps) => {
  const requestConfig = HISTORY_IMPORT_COLUMN_CONFIG[HistoryImportSource.Request];
  const traceConfig = HISTORY_IMPORT_COLUMN_CONFIG[HistoryImportSource.Trace];
  const sharedProps = {
    onOpenChange,
    onImport,
    isImporting,
    importProgress: null,
    selectionLimit: 1 as const,
    tableId,
    sheetId,
    targetColumnId: target?.columnId ?? null,
  };

  return (
    <>
      <AddFromRequestHistoryButton
        open={target?.type === HistoryImportSource.Request}
        actionLabel={requestConfig.cellImportActionLabel}
        title={requestConfig.cellImportTitle}
        {...sharedProps}
      />
      <AddFromTracesButton
        open={target?.type === HistoryImportSource.Trace}
        actionLabel={traceConfig.cellImportActionLabel}
        title={traceConfig.cellImportTitle}
        {...sharedProps}
      />
    </>
  );
};

export default AnchorCellImportDialogs;
